import {createApp, reactive, ref} from 'vue';
import moment from 'moment';
import { uuid } from 'vue-uuid';
import md5 from 'js-md5';
import {getQRcode} from '../../common/util.js';

import config from '../config.js';
import event from '../event.js';
import toast from '../toast.js';
import mqtt from '../mqtt.js';
import { num3, getQueryString } from '../util.js';

import project from '../../model/project.js';
import user from '../../model/user.js';
import ali from '../../model/ali.js';

import dyModal from '../../components/dy-modal/dy-modal.vue';
import member from "../../json/member.json";
	
import util from './util.js';
import hotkey from './hotkey.js';
import pano from './pano.js';
import group from './group.js';
import model from './model.js';
import button from './button.js';
import hotspot from './hotspot.js';

function goPano(){
	uni.reLaunch({ url:'./pano?' + getQueryString() });
}

function goModel(){
	uni.reLaunch({ url:'./model?' + getQueryString() });
}

function goEditor(){
	uni.reLaunch({ url:'./editor?' + getQueryString() });
}

function goNavigation(){
	uni.reLaunch({ url:'./navigation?' + getQueryString() });
}


function goLogin(){
	uni.reLaunch({ url:'../login/login'});
}

function goHome(){
	uni.reLaunch({ url:'../index/index'});
}

function goList(){
	uni.reLaunch({ url:'../editor/list'});
}

function goModifyInfo(){
	uni.reLaunch({ url:'../editor/user'});
}

function goModifyPassword(){
	uni.reLaunch({ url:'../editor/password'});
}

function goAgreement(){
	window.open('/#/pages/agreement/agreement');
}

function goHelp(){
	window.open('/#/pages/help/help');
}

function goPay(){
	window.open('/#/pages/shop/shop');
}

function goMember(){
	window.open('/#/pages/member/member');
}

function doLogout(){
	dyEditor.clearToken();
	uni.navigateTo({ url: '../index/index' });
}

////////////////////////////////////////////////////////////////
//项目相关操作

//生成项目
function doBuild(){
	project.build({id:config.data.id}, res=>{
		config.data.buildStatus = 1;
		let buildData = {
			status : 1,
			percent : 0,
			msg : ''
		}
		
		localStorage.setItem('build_'+config.data.id, JSON.stringify(buildData));
		
		buildStatus();
	}, err=>{
		editor.dialog.close('build');
		editor.dialog.show({
			title:'模型生成提示',
			content:{
				title:'生成模型失败。',
				text:err.msg,
			}
		});
	});
}

//检查资源并生成项目
function build(){
	const models	= config.data.models;
	const panos		= config.data.panos;
	
	// 未上传全景图和模型文件
	if(panos.length==0 && models.length==0){
		editor.dialog.show({
			title:'模型生成失败',
			confirmText:'我知道了',
			cancel:false,
			content:{
				title:'模型生成失败',
				text:'请上传全景图片和与之对应的3D模型后再试'
			},
		});
		
		return false;
	}
	
	// 未上传模型文件
	if(models.length==0){
		editor.dialog.show({
			title:'模型生成失败',
			confirmText:'去上传3D模型',
			cancel:true,
			cancelText:'稍后生成',
			content:{
				title:'模型生成失败',
				text:'请先上传与该全景对应的3D模型后再试'
			},
			success:res=>{
				if(res.confirm) goModel();
			}
		});
		
		return false;
	}
	
	//模型坐标重复
	// if(dyEditor.model.offsetOverlap()){
	// 	editor.dialog.show({
	// 		title:'模型生成失败',
	// 		confirmText:'查看3D模型',
	// 		cancel:true,
	// 		cancelText:'稍后生成',
	// 		content:{
	// 			text:'你上传的3D模型存在坐标重叠，请检查后再试。\n可尝试重新上传fbx坐标文件或手动调整模型位置解决。'
	// 		},
	// 		success:res=>{
	// 			if(res.confirm) goModel(5);
	// 		}
	// 	});
	// 	return false;
	// }
	
	
	// 未上传全景图
	if(panos.length==0){
		editor.dialog.show({
			title:'模型生成失败',
			confirmText:'去上传全景图片',
			cancel:true,
			cancelText:'稍后生成',
			content:{
				title:'模型生成失败',
				text:'请先上传与该模型对应的全景图片后再试'
			},
			success:res=>{
				if(res.confirm) goPano();
			}
		});
		return false;
	}
	
	//全景图坐标重复
	// if(dyEditor.pano.offsetOverlap('pano')){
	// 	editor.dialog.show({
	// 		title:'模型生成失败',
	// 		confirmText:'查看全景图',
	// 		cancel:true,
	// 		cancelText:'稍后生成',
	// 		content:{
	// 			text:'你上传的全景图存在坐标重叠，请检查后再试。\n可尝试重新上传fbx坐标文件或手动调整模型位置解决。'
	// 		},
	// 		success:res=>{
	// 			if(res.confirm) goPano(5);
	// 		}
	// 	});
	// 	return false;
	// }
	
	//模型文件未处理完成
	for(let i=0; i<models.length; i++){
		if(models[i].status!=3){
			editor.dialog.show({
				title:'模型生成失败',
				confirmText:'查看3D模型',
				cancel:true,
				cancelText:'稍后生成',
				content:{
					text:'存在未处理完成的模型素材，当前无法生成，请在处理完成后再试'
				},
				success:res=>{
					if(res.confirm) goModel(5);
				}
			});
			return false;
		}
	}
	
	//全景文件未处理完成
	for(let i=0; i<panos.length; i++){
		const pano = panos[i];
		if(pano.status!=3 && pano.mode==0){
			editor.dialog.show({
				title:'模型生成失败',
				confirmText:'查看全景图',
				cancel:true,
				cancelText:'稍后生成',
				content:{
					text:'存在未处理完成的全景图，当前无法生成，请在处理完成后再试'
				},
				success:res=>{
					if(res.confirm) goPano(5);
				}
			});
			return false;
		}
	}
	
	//模型是否生成过
	if(config.data.buildStatus){
		editor.dialog.show({
			title:'模型生成提示',
			confirmText:'重新生成',
			cancel:true,
			cancelText:'取消生成',
			content:{
				title:'重新生成会覆盖现有模型，确认生成吗？',
				// text:'重新生成后，数据无法回退，请谨慎操作。'
			},
			success:res=>{
				if(res.confirm) {
					save(doBuild);	
				}
			}
		});
	} else {
		save(doBuild);
	}
	
	return true;
}

//检查是否有正在生成的任务
function buildStatus(){
	//如果有未生成完的任务则弹窗提示
	if(config.data.buildStatus==1 || config.data.buildStatus==2){
		
		var build = JSON.parse(localStorage.getItem('build_'+config.data.id));
		
		editor.dialog.build({
			title:'生成模型',
			confirmText:'完成生成',
			disable:true,
			build:build,
			success:res=>{
				//if(res.status==3) window.location.reload();
			}
		});
		
		mqtt.on('dym', res=>{
			build.status = res.status;
			config.data.buildStatus = res.status;
			event.emit("dy3dBuild", res.status);

			let buildData = {
				status : res.status,
				percent : 0,
				msg : ''
			}
			
			localStorage.setItem('build_'+config.data.id, JSON.stringify(buildData));
			//更新提示框数据
			editor.dialog.update('build', {
				title:'生成模型',
				confirmText:'完成生成',
				disable:true,
				build:build,
				success:res=>{
					//if(res.data.build.status==3) window.location.reload();
				}
			});	
			
			switch(res.status){
				case 2:
					if(build.percent < res.percent){
						
						let buildData = {
							status : res.status,
							percent : res.percent,
							msg : res.msg
						}
						localStorage.setItem('build_'+config.data.id, JSON.stringify(buildData));
						
						build.percent	= res.percent;
						build.msg	 	= res.msg;
					}
					break;
					
				case 3:
					build.msg = '模型制作完成！';
					editor.dialog.enable('build');
					localStorage.removeItem('build_'+config.data.id);
					toast.success(build.msg);
					break;
					
				case 4:
					build.msg = typeof(res.error)=='string' ? res.error : '模型制作失败！';
					editor.dialog.enable('build');
					toast.error(build.msg);
					break;
			}
		}, true);
	}
}
//修正平面图数据
function correctPlan(){
	let json = {
			img : '',
			offset : {
				x : 0,
				y : 0,
				z : 0
			},
			rotate : {
				x : 0,
				y : 0,
				z : 0
			},
			scale : {
				x : 1,
				y : 1
			},
			lockRatio : true,
		}
	let planCount  = config.data.plan.floor.length;
	let floorCount = config.data.floors.length;
	if(planCount < floorCount){
		for(let i=0; i<floorCount-planCount; i++){
			config.data.plan.floor.push(json)
		}
	}else if(planCount > floorCount){
		config.data.plan.floor.length = floorCount;
	}
}

//保存项目配置
function save(success){
	config.data.version += 1;
	if(config.data.floors) correctPlan();
	let json = config.toJSON();
	project.save(json, res=>{
		config.needsUpdate	= false;
		config.panoUpdate	= false;
		config.modelUpdate	= false;
		config.data.storage			= Number(res.project);
		dyEditor.user.storage.used	= Number(res.used);
		dyEditor.user.storage.total	= Number(res.total);
		
		window.sessionStorage.setItem('storage_used',	res.used);
		window.sessionStorage.setItem('storage_total',	res.total);
		
		success ? success() : toast.success('保存成功');
	});
}

//发布项目
function publish(success){
	if(config.data.type==0){
		this.toast.error('未添加作品分类，无法发布');
		return false;
	}
	
	save(()=>{
		project.publish({id:config.data.id},()=>{
			this.toast.success('发布成功');
			config.data.publish = true;
			success && success();
			
			dyEditor.dialog.publishSuccess({
				title:'作品发布成功',
				confirmText:'关闭弹窗',
				width:'650px',
				height:'400px',
				url:config.oss + '/vr/' + config.data.id,
				openUrl:(url)=>{
					window.open(url, '_blank');
				},
				copy:(url)=>{
					copyUrl(url);
				},
			});
			// window.open(config.oss + '/vr/' + config.data.id, '_blank');
		});
	});
	
	return true;
}

function copyUrl(url) {
	let createInput = document.createElement('input');
	createInput.value = url;
	document.body.appendChild(createInput);
	createInput.select(); // 选择对象
	document.execCommand("Copy"); // 执行浏览器复制命令
	createInput.className = 'createInput';
	createInput.style.display = 'none';
	dyEditor.toast.show('链接已复制','#61B500');
}
			
function getVersionText(){
	let text = {
		0 : '免费版', 
		1 : '创作版',
		2 : '高级版',
		3 : '商业版',
	}
	return text[editor.user.level];
}

function getQRImage(url, text, success) {
	let icon = url == './static/logo.png' ? dyEditor.user.avatar : url;
	if(icon.substring(0,8) == '/avatar/') icon = '/static/logo.png';
	getQRcode({
		text:text + '?' + new Date().getTime(),
		src:icon,
		success:(img)=>{
			success && success(img);
		}
	});
}

let types;

function getTypes(success){
	if(!types){
		project.type({},res=>{
			types = res;
			success(types);
		});
	} else {
		success(types);
	}
}

let editor = {
	num3,
	toast,
	init,
	save,
	publish,
	util,
	hotkey,
	pano,
	group,
	model,
	button,
	hotspot,
	goPano,
	goModel,
	goEditor,
	goNavigation,
	buildStatus,
	build,
	dialog:null,
	currentPano:{
		highlight : false,
		id:''
	},
	//checkStorage,
	getVersionText,
	getQRImage,
	getTypes,
	user:{
		uid			: window.sessionStorage.getItem('uid') || '',
		level		: Number(window.sessionStorage.getItem('level')) || 0,
		nickname	: window.sessionStorage.getItem('nickname') || '',
		avatar		: config.avatar + window.sessionStorage.getItem('avatar'),
		storage		: {
			used	: Number(window.sessionStorage.getItem('storage_used')),
			total	: Number(window.sessionStorage.getItem('storage_total')),
		}
	},
	member		: {
		"name": "免费版",
		"level": 0,
		"pano": 50,
		"model": 50,
		"hotspot": 50,
		"logo": false,
		"button": false,
		"dy3d": false,
		"ad": false,
		"terrain": false,
		"space": 1024,
		"cdn": false
	},
	isMac:()=>{
		return /macintosh|mac os x/i.test(navigator.userAgent);
	},
	uuid:()=>{
		return md5(uuid.v4()).substr(16);
	},
	getToken:()=>{
		let token;
		
		let reg = new RegExp("(^|&)token=([^&]*)(&|$)", "i");
		let r = window.location.search.substr(1).match(reg);
		if (r != null) {
			token = unescape(r[2]).replace('#/', '');
			window.localStorage.setItem('token', token);
			window.history.replaceState({}, null, '/');
		} else {
			token = window.localStorage.getItem('token');
			if(!token) {
				window.localStorage.removeItem('token');
				// window.location.href = config.server + '/#/pages/login/login';
				// uni.redirectTo({
				// 	url:'../pages/login/login',
				// })
			}
		}
		
		return token;
	},
	setToken:(token)=>{
		return window.localStorage.setItem('token', token);
	},
	
	clearToken:()=>{
		window.localStorage.removeItem('token');
	},

	goLogin,
	goHome,
	goList,
	goModifyInfo,
	goModifyPassword,
	goAgreement,
	goPay,
	goHelp,
	goMember,
	doLogout,
	type:'pano',
};

function init(){
	const div = document.createElement('div');
	document.body.appendChild(div);
	var vm = createApp(dyModal);
	vm.config.globalProperties.formatTime = time=>{ return moment(time*1000).format('YYYY-MM-DD~HH:mm') };
    vm.config.globalProperties.dyEditor = editor;
	vm.config.globalProperties.dyConfig = config;
	return vm.mount(div);
}

editor.dialog = init();
editor.member = member[editor.user.level];
// editor.member = member[0];
export default editor;